<nav class="navbar navbar-expand header">
  <a class="navbar-brand" href="#"
    ><img src="assets/ulsap.svg" alt="La salle pachuca"
  /></a>
  <button
    class="navbar-toggler"
    type="button"
    data-toggle="collapse"
    data-target="#navbarText"
    aria-controls="navbarText"
    aria-expanded="false"
    aria-label="Toggle navigation"
  >
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse no-print" id="navbarText">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item active">
        <!-- <a class="nav-link hlink" (click)="inicio()" style="color: #fff; font-weight: bolder;">Inicio</a> -->
        <a
          class="nav-link hlink"
          routerLink="/"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          >Inicio</a
        >
      </li>
      <li class="nav-item">
        <!-- <a class="nav-link hlink" (click)="alumnos()" style="color: #fff; font-weight: bolder;">Lista alumnos</a> -->
        <a
          class="nav-link hlink"
          routerLink="/lista-alumnos"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          >Lista alumnos</a
        >
      </li>
      <li *ngIf="registrar" class="nav-item">
        <a
          class="nav-link hlink"
          routerLink="/reporte"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          >Reporte Excel</a
        >
      </li>
      <li class="nav-item">
        <a
          class="nav-link hlink"
          (click)="cerrarSesion()"
          style="color: #fff; font-weight: bolder"
          >Cerrar sesión</a
        >
      </li>
    </ul>
  </div>
  <img src="assets/headers.png" alt="" class="header-img d-none d-md-block" />
</nav>
